<template>
  <div class="px-8 py-10 bg-white">
    <div class="grid grid-cols-5 gap-6">
      <div
        v-for="item in related_items1"
        :key="item.objectId"
        class="cmscard cursor-pointer"
        @click="handleclick(item.routes)"
      >
        <div>
          <!-- <feather-icon
            :class="item.icon === 'PlusCircleIcon' ? 'text-success' : ''"
            :icon="item.icon"
            svgClasses="w-16 h-16"
            class="cursor-pointer flex justify-center text-lightgray"
          /> -->
          <div class="flex justify-center">
            <img :src="item.image" alt="icons" />
          </div>

          <p
            class="font-semibold w-11/12 mx-auto text-gray fsize14 text-center mt-4 px-2"
          >
            {{ item.description }}
          </p>
          <h2
            v-if="
              item.description === 'Seo & Google Analytics' ||
              item.description === 'Website Forms' ||
              item.description === 'Ecommerce Settings'
            "
            class="py-2 px-4 fit-content m-auto rounded-4px fsize12 mt-4 text-center bg-primary text-white"
          >
            Coming Soon
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      related_items1: [
        {
          id: "01",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/Frame.png",
          icon: "FileTextIcon",
          description: "Website Content",
          // routes: "CMS-pages",
          routes: "WebsiteForm",
        },

        {
          id: "03",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/media.png",
          icon: "ImageIcon",
          description: "Website Media",
          routes: "WebsiteMedia",
        },
        {
          id: "04",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/form.png",
          icon: "EditIcon",
          description: "Website Menu",
          routes: "WebsiteMenu",
        },
        {
          id: "02",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/seo.png",
          icon: "TrendingUpIcon",
          description: "Seo & Google Analytics",
          routes: "coming",
        },
        {
          id: "04",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/form.png",
          icon: "EditIcon",
          description: "Website Forms",
          routes: "coming",
        },
        {
          id: "05",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/cms/cms/setting.png",
          icon: "ShoppingCartIcon",
          description: "Ecommerce Settings",
          routes: "coming",
        },
        // {
        //   id: "06",
        //   icon: "PlusCircleIcon",
        //   description: "Add New Features",
        // },
      ],
    };
  },
  methods: {
    handleclick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style></style>
